export const AUTH = {
    NAMESPACE: 'auth',
    //向后台请求当前登录用户的权限
    REQUEST_AUTH: 'requestAuth'
}

export const LIST = {
    NAMESPACE: 'list',
    //向后台请求当前登录用户的权限
    REQUEST_LIST: 'requrestData'
}